import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import Moment from 'moment';
import WhiteboardMenuMixin from '@/core/mixins/whiteboard-menu.mixin';
import { TOAST_TYPES } from '@/plugins/ed-toast/values/ed-toast.values';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import KEYS from '@/values/keys';
import { HomeworksService } from '@/homework/services/homeworks.service';
import ToolService from '@/providers/tools';

@Component({})
export default class EdWhiteboardMenuHistory extends Mixins(WhiteboardMenuMixin) {

    @Prop()
    public readonly history: any;
    public loading: boolean = false;

    get sectionName(): string {
        return ToolService.exitSpecialChars(this.history.sectionName);
    }
    
    get allowRestore(){
        return this.history.allowRestore;
    }

    formatDate(date){
        return Moment(date).format('DD/MM/YYYY hh:mm A');
    }

    recover(){
        this.$EdModal.createConfirmationModal(
            {
                title: this.$i18n.t('homeworks.actionRestore'),
                body: `${this.$t('homeworks.questionActionRestore')}`,
                action: this.doRecover
            }
        );
    }

    doRecover(){
        this.loading = true;
        HomeworksService.recoverHistoryBoard(this.history.info.id).then(()=>{
            this.$edEventBus.$emit(SCREEN_MIRRORING_EVENTS.ON_CLOSE_HOMEWORK_VIEWER);
            this.$EdToast.create({
                msg: `${this.$t('homeworks.documentRestored', {versionId: this.history.info.id})}`,
                type: TOAST_TYPES.SUCCESS,
                top: '3rem',
                timeout: 3000
            });
            this.loading = false;
        }).catch(()=>{
            this.loading = false;
            this.$EdModal.createMessageModal({
                title: this.$i18n.t('homeworks.errorTitle'),
                body: this.$i18n.t('homeworks.errorDocumentRestored'),
                type: KEYS.EVENT_TYPES.DANGER
            });
        })
    }
}
